module.exports = __webpack_public_path__ + "static/media/1POLICY9.c9bd95d5.jpg";